import { render, staticRenderFns } from "./weight-required.vue?vue&type=template&id=6192e6e7&"
import script from "./weight-required.vue?vue&type=script&lang=js&"
export * from "./weight-required.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports